import { useState, useEffect } from "react";
import { C, Stars } from "../components/shared";

export function LandingPage({ onStart, onTradeLogin }) {
  const [visible, setVisible] = useState(false);
  useEffect(()=>{ setTimeout(()=>setVisible(true),80); },[]);

  const reviews = [
    { name:"Sarah M.", location:"Manchester", car:"VW Golf", rating:5, text:"Got 4 quotes within a day. Ended up saving over £200 compared to the first quote I had. Unbelievably easy to use." },
    { name:"James T.", location:"Rochdale", car:"Ford Transit", rating:5, text:"Was dreading calling around garages. Filled this in on my lunch break, had 3 bodyshops ring me the same afternoon. Booked straight away." },
    { name:"Priya K.", location:"Bolton", car:"Audi A3", rating:5, text:"So much better than ringing round yourself. The bodyshop that called was brilliant — already knew exactly what I needed from the photos." },
    { name:"Dave H.", location:"Oldham", car:"BMW 5 Series", rating:5, text:"Thought it was too good to be true. It wasn't. Booked in within 48 hours and the price was better than I expected." },
    { name:"Lauren B.", location:"Leeds", car:"Mini Cooper", rating:5, text:"Really impressed. Shops come to you rather than the other way around. Should have been a thing years ago." },
    { name:"Chris W.", location:"Sheffield", car:"VW T5 Van", rating:5, text:"Needed my van sorting urgently. Had 4 quotes by the next morning. The whole process took about 2 minutes to fill in." },
    { name:"Donna R.", location:"Liverpool", car:"Ford Focus", rating:5, text:"Was nervous about giving my details but my number was never shared until I'd heard from a shop. Felt really safe." },
    { name:"Tariq A.", location:"Bradford", car:"Mercedes C Class", rating:5, text:"Three bodyshops called me within a few hours. Ended up going with the second one — saved about £180 on the job." },
    { name:"Gemma S.", location:"Huddersfield", car:"Nissan Qashqai", rating:5, text:"Had no idea what a bumper replacement would cost. Got quotes from £180 to £340. Really helpful to compare." },
    { name:"Mark O.", location:"Bury", car:"Audi A4", rating:5, text:"Used it after someone reversed into me in a car park. Shops were professional and quick to get in touch. Highly recommend." },
    { name:"Fatima H.", location:"Rochdale", car:"Toyota Yaris", rating:5, text:"I was expecting spam calls but I only heard from verified bodyshops. One even came to assess the car at my house." },
    { name:"Steve L.", location:"Wigan", car:"Ford Ranger", rating:5, text:"Big job on my pickup truck. Got 5 quotes and chose the best value one. Would never have found that garage on my own." },
  ];

  const anim = (delay=0) => ({ opacity: visible?1:0, transform: visible?"translateY(0)":"translateY(24px)", transition:`opacity 0.6s ease ${delay}ms, transform 0.6s ease ${delay}ms` });

  return (
    <div style={{ minHeight:"100vh", background:C.dark, color:C.text, fontFamily:"'DM Sans',sans-serif" }}>
      <style>{`
        @media(max-width:600px){ .desktop-grid{ display:flex !important; overflow-x:auto !important; flex-wrap:nowrap !important; } .hero-btns{ flex-direction:column !important; } }
        ::-webkit-scrollbar{display:none}
        * { box-sizing: border-box; }
      `}</style>

      {/* NAV */}
      <nav style={{ padding:"16px 24px", display:"flex", alignItems:"center", justifyContent:"space-between", position:"sticky", top:0, zIndex:50, background:"rgba(8,8,8,0.94)", backdropFilter:"blur(12px)", borderBottom:"1px solid rgba(255,255,255,0.05)", maxWidth:"100%" }}>
        <div style={{ fontSize:20, fontWeight:900 }}><span style={{ color:C.red }}>Quote</span><span style={{ color:C.text }}>MyBodywork</span></div>
        <div style={{ display:"flex", alignItems:"center", gap:12 }}>
          <button onClick={onStart} style={{ background:C.red, color:"#fff", border:"none", fontSize:13, padding:"8px 18px", borderRadius:8, cursor:"pointer", fontFamily:"inherit", fontWeight:700, display:"none" }} className="nav-cta">Get Free Quotes</button>
          <button onClick={onTradeLogin} style={{ background:"transparent", border:`1px solid ${C.border}`, color:C.muted, fontSize:12, padding:"6px 14px", borderRadius:8, cursor:"pointer", fontFamily:"inherit", fontWeight:500 }}>Trade login</button>
        </div>
      </nav>

      {/* HERO */}
      <section style={{ padding:"64px 24px 56px", maxWidth:800, margin:"0 auto", textAlign:"center" }}>
        <div style={{ ...anim(0), display:"inline-flex", alignItems:"center", gap:7, background:"rgba(232,52,26,0.12)", border:"1px solid rgba(232,52,26,0.3)", color:C.red, fontSize:12, fontWeight:700, padding:"5px 14px", borderRadius:20, marginBottom:24 }}>
          <span style={{ width:6, height:6, borderRadius:"50%", background:C.red, display:"inline-block" }} />
          UK-WIDE · FREE TO USE · VERIFIED BODYSHOPS ONLY
        </div>
        <h1 style={{ ...anim(100), fontSize:"clamp(36px,5vw,64px)", fontWeight:900, lineHeight:1.05, marginBottom:20, letterSpacing:"-2px" }}>
          Stop chasing bodyshops.<br /><span style={{ color:C.red }}>Let them come to you.</span>
        </h1>
        <p style={{ ...anim(200), fontSize:"clamp(15px,2vw,18px)", color:"#AAAAAA", lineHeight:1.8, marginBottom:40, maxWidth:520, margin:"0 auto 40px" }}>
          Fill in one short form. Verified local bodyshops contact you directly with quotes. No calling around. No spam. Completely free.
        </p>
        <div style={{ ...anim(300), display:"flex", gap:12, justifyContent:"center", flexWrap:"wrap" }}>
          <button onClick={onStart} style={{ background:C.red, color:"#fff", border:"none", borderRadius:14, padding:"18px 48px", fontSize:17, fontWeight:800, cursor:"pointer", fontFamily:"inherit", boxShadow:"0 8px 32px rgba(232,52,26,0.35)", whiteSpace:"nowrap" }}>
            Get My Free Quotes →
          </button>
          <div style={{ display:"flex", alignItems:"center", gap:8 }}>
            <div style={{ display:"flex" }}>
              {["S","J","P","D","L"].map((l,i)=>(<div key={i} style={{ width:32, height:32, borderRadius:"50%", background:`hsl(${i*60},40%,30%)`, border:"2px solid #080808", display:"flex", alignItems:"center", justifyContent:"center", fontSize:12, fontWeight:700, marginLeft: i>0?-8:0 }}>{l}</div>))}
            </div>
            <div style={{ textAlign:"left" }}>
              <div style={{ fontSize:13, fontWeight:700 }}>4,800+ quotes sent</div>
              <div style={{ fontSize:11, color:C.muted }}>this month alone</div>
            </div>
          </div>
        </div>
        <p style={{ fontSize:12, color:C.muted, marginTop:16 }}>Takes 2 minutes · No account needed · 100% free</p>
      </section>

      {/* STATS BAR */}
      <div style={{ background:C.card, borderTop:`1px solid ${C.border}`, borderBottom:`1px solid ${C.border}`, padding:"24px" }}>
        <div style={{ display:"grid", gridTemplateColumns:"repeat(4,1fr)", gap:16, maxWidth:800, margin:"0 auto", textAlign:"center" }}>
          {[["4,800+","Quotes sent this month"],["9 min","Average response time"],["4.9 ★","Customer rating"],["100%","Free for customers"]].map(([v,l])=>(
            <div key={l}>
              <div style={{ fontSize:"clamp(18px,3vw,26px)", fontWeight:900, color:C.text }}>{v}</div>
              <div style={{ fontSize:"clamp(10px,1.5vw,12px)", color:C.muted, marginTop:4, lineHeight:1.4 }}>{l}</div>
            </div>
          ))}
        </div>
      </div>

      {/* HOW IT WORKS */}
      <section style={{ padding:"72px 24px", maxWidth:900, margin:"0 auto" }}>
        <div style={{ textAlign:"center", marginBottom:48 }}>
          <div style={{ fontSize:11, fontWeight:700, color:C.red, textTransform:"uppercase", letterSpacing:"2px", marginBottom:12 }}>Simple process</div>
          <h2 style={{ fontSize:"clamp(28px,4vw,42px)", fontWeight:900, letterSpacing:"-1px" }}>Get quotes in 3 easy steps</h2>
        </div>
        <div style={{ display:"grid", gridTemplateColumns:"repeat(auto-fit,minmax(240px,1fr))", gap:24 }}>
          {[
            { icon:"📸", n:"01", title:"Describe your damage", body:"Fill in a short form and upload a few photos. Takes less than 2 minutes on your phone." },
            { icon:"🔔", n:"02", title:"Bodyshops come to you", body:"Verified local bodyshops in your area review your job and contact you directly. No middleman." },
            { icon:"✅", n:"03", title:"Pick your best quote", body:"Compare quotes and choose the bodyshop you want. No obligation, no pressure." },
          ].map((step,i)=>(
            <div key={i} style={{ background:C.card, border:`1px solid ${C.border}`, borderRadius:16, padding:"28px 24px" }}>
              <div style={{ fontSize:36, marginBottom:16 }}>{step.icon}</div>
              <div style={{ fontSize:11, color:C.red, fontWeight:700, letterSpacing:"0.5px", marginBottom:8 }}>STEP {step.n}</div>
              <div style={{ fontSize:18, fontWeight:800, marginBottom:10 }}>{step.title}</div>
              <div style={{ fontSize:14, color:"#999", lineHeight:1.7 }}>{step.body}</div>
            </div>
          ))}
        </div>
        <div style={{ textAlign:"center", marginTop:40 }}>
          <button onClick={onStart} style={{ background:C.red, color:"#fff", border:"none", borderRadius:14, padding:"16px 48px", fontSize:16, fontWeight:800, cursor:"pointer", fontFamily:"inherit" }}>Start My Free Quote →</button>
        </div>
      </section>

      {/* TRUST BADGES */}
      <div style={{ background:C.card, borderTop:`1px solid ${C.border}`, borderBottom:`1px solid ${C.border}`, padding:"48px 24px" }}>
        <div style={{ maxWidth:900, margin:"0 auto" }}>
          <div style={{ textAlign:"center", fontSize:11, fontWeight:700, color:C.muted, textTransform:"uppercase", letterSpacing:"1.5px", marginBottom:28 }}>Why customers trust us</div>
          <div style={{ display:"grid", gridTemplateColumns:"repeat(auto-fit,minmax(180px,1fr))", gap:16 }}>
            {[
              { icon:"🔒", title:"Your data is safe", body:"Details only shared with verified shops after they pay for your lead" },
              { icon:"✅", title:"Verified shops only", body:"Every bodyshop is checked via Companies House before joining" },
              { icon:"🆓", title:"Always free", body:"Getting quotes costs you nothing, ever" },
              { icon:"🚫", title:"Zero spam", body:"We never sell your data or add you to mailing lists" },
            ].map((t,i)=>(
              <div key={i} style={{ background:C.dark, border:`1px solid ${C.border}`, borderRadius:14, padding:"20px 18px" }}>
                <div style={{ fontSize:28, marginBottom:10 }}>{t.icon}</div>
                <div style={{ fontSize:14, fontWeight:700, marginBottom:6 }}>{t.title}</div>
                <div style={{ fontSize:13, color:"#888", lineHeight:1.6 }}>{t.body}</div>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* REVIEWS */}
      <section style={{ padding:"72px 24px" }}>
        <div style={{ maxWidth:1200, margin:"0 auto" }}>
          <div style={{ textAlign:"center", marginBottom:40 }}>
            <div style={{ fontSize:11, fontWeight:700, color:C.red, textTransform:"uppercase", letterSpacing:"2px", marginBottom:12 }}>Real customers</div>
            <h2 style={{ fontSize:"clamp(28px,4vw,42px)", fontWeight:900, letterSpacing:"-1px", marginBottom:16 }}>Don't just take our word for it</h2>
            <div style={{ display:"inline-flex", alignItems:"center", gap:12, background:C.card, border:`1px solid ${C.border}`, borderRadius:14, padding:"12px 24px" }}>
              <div>
                <div style={{ fontSize:28, fontWeight:900, lineHeight:1 }}>4.9</div>
                <Stars />
              </div>
              <div style={{ width:1, height:36, background:C.border }} />
              <div style={{ textAlign:"left" }}>
                <div style={{ fontSize:14, fontWeight:700, color:"#00B67A" }}>★ Trustpilot</div>
                <div style={{ fontSize:12, color:C.muted }}>Based on 847 reviews</div>
              </div>
            </div>
          </div>

          {/* Grid on desktop, scroll on mobile */}
          <div className="desktop-grid" style={{ display:"grid", gridTemplateColumns:"repeat(auto-fill,minmax(280px,1fr))", gap:16 }}>
            {reviews.map((r,i)=>(
              <div key={i} style={{ background:C.card, border:`1px solid ${C.border}`, borderRadius:16, padding:"22px 20px", flexShrink:0 }}>
                <Stars n={r.rating} />
                <p style={{ fontSize:14, color:"#CCCCCC", lineHeight:1.7, margin:"12px 0 16px" }}>"{r.text}"</p>
                <div style={{ display:"flex", alignItems:"center", gap:10 }}>
                  <div style={{ width:36, height:36, borderRadius:"50%", background:`hsl(${i*30},35%,25%)`, border:`1px solid ${C.border}`, display:"flex", alignItems:"center", justifyContent:"center", fontSize:14, fontWeight:700, flexShrink:0 }}>{r.name[0]}</div>
                  <div>
                    <div style={{ fontSize:13, fontWeight:700 }}>{r.name}</div>
                    <div style={{ fontSize:11, color:C.muted }}>{r.car} · {r.location}</div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* FINAL CTA */}
      <section style={{ padding:"56px 24px 72px", maxWidth:700, margin:"0 auto", textAlign:"center" }}>
        <div style={{ background:"linear-gradient(135deg,#1a0a06,#200e08)", border:"1px solid rgba(232,52,26,0.2)", borderRadius:24, padding:"56px 40px" }}>
          <h2 style={{ fontSize:"clamp(28px,4vw,42px)", fontWeight:900, letterSpacing:"-1px", lineHeight:1.1, marginBottom:16 }}>
            Ready to get your<br /><span style={{ color:C.red }}>bodywork sorted?</span>
          </h2>
          <p style={{ fontSize:15, color:"#999", lineHeight:1.8, marginBottom:36, maxWidth:400, margin:"0 auto 36px" }}>
            Join thousands of UK drivers who've already used QuoteMyBodywork to save time and money.
          </p>
          <button onClick={onStart} style={{ background:C.red, color:"#fff", border:"none", borderRadius:14, padding:"18px 56px", fontSize:17, fontWeight:800, cursor:"pointer", fontFamily:"inherit", boxShadow:"0 6px 28px rgba(232,52,26,0.3)" }}>
            Get My Free Quotes Now →
          </button>
          <p style={{ fontSize:12, color:C.muted, marginTop:16 }}>Free · Takes 2 minutes · No spam ever</p>
        </div>
      </section>

      {/* FOOTER */}
      <footer style={{ background:C.card, borderTop:`1px solid ${C.border}`, padding:"32px 24px", textAlign:"center" }}>
        <div style={{ fontSize:16, fontWeight:900, marginBottom:10 }}><span style={{ color:C.red }}>Quote</span><span style={{ color:C.text }}>MyBodywork</span></div>
        <div style={{ fontSize:12, color:C.muted, lineHeight:2 }}>
          🔒 GDPR Compliant · Your data is never sold · Verified tradespeople only<br />
          © 2026 QuoteMyBodywork Ltd · All rights reserved
        </div>
      </footer>
    </div>
  );
}

export function TradeLoginPage({ onSelect, onBack }) {
  return (
    <div style={{ minHeight:"100vh", background:C.dark, display:"flex", flexDirection:"column", justifyContent:"center", alignItems:"center", padding:"32px 24px", color:C.text, fontFamily:"'DM Sans',sans-serif" }}>
      <div style={{ width:"100%", maxWidth:520 }}>
        <button onClick={onBack} style={{ background:"transparent", border:"none", color:C.muted, cursor:"pointer", fontFamily:"inherit", fontSize:13, display:"flex", alignItems:"center", gap:6, padding:"0 0 32px" }}>← Back to main site</button>
        <div style={{ fontSize:11, fontWeight:700, color:C.muted, textTransform:"uppercase", letterSpacing:"1.5px", marginBottom:8 }}>Trade access</div>
        <div style={{ fontSize:32, fontWeight:900, letterSpacing:"-1px", marginBottom:6 }}><span style={{ color:C.red }}>Quote</span>MyBodywork</div>
        <div style={{ fontSize:14, color:C.muted, marginBottom:40, lineHeight:1.6 }}>Partner & admin portal. Not for customers.</div>
        <div style={{ display:"flex", flexDirection:"column", gap:14 }}>
          {[
            { id:"bodyshop", icon:"🏭", title:"Bodyshop portal", sub:"Sign in or register to buy leads in your area", badge:"Sign in / Register", color:C.blue },
            { id:"admin", icon:"🔐", title:"Admin panel", sub:"Manage leads, shops, pricing & settings", badge:"Admin only", color:C.red },
          ].map(p=>(
            <div key={p.id} onClick={()=>onSelect(p.id)} style={{ background:C.card, border:`1px solid ${C.border}`, borderRadius:16, padding:"22px 20px", cursor:"pointer", display:"flex", alignItems:"center", gap:16, transition:"border-color 0.15s" }}
              onMouseEnter={e=>e.currentTarget.style.borderColor=p.color}
              onMouseLeave={e=>e.currentTarget.style.borderColor=C.border}>
              <div style={{ width:52, height:52, borderRadius:14, background:`${p.color}18`, border:`1px solid ${p.color}44`, display:"flex", alignItems:"center", justifyContent:"center", fontSize:26, flexShrink:0 }}>{p.icon}</div>
              <div style={{ flex:1 }}>
                <div style={{ fontSize:17, fontWeight:800, marginBottom:4 }}>{p.title}</div>
                <div style={{ fontSize:13, color:C.muted, lineHeight:1.5 }}>{p.sub}</div>
              </div>
              <div style={{ fontSize:11, color:p.color, fontWeight:700, background:`${p.color}18`, border:`1px solid ${p.color}44`, padding:"5px 12px", borderRadius:20, whiteSpace:"nowrap", flexShrink:0 }}>{p.badge}</div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default LandingPage;
